export default {
  // PROFILE CANNOT BE UPDATED INTERNAL CODE LABEL
  CANNOT_BE_UPDATED: 'profileservice.updateprofile.common',
};
